/* eslint-disable */
// Code generated by versionctl from datalogger-versioning/catalog.yaml; DO NOT EDIT.
export const VERSION_CATALOG_FINGERPRINT = "4b54c9e7d5bd56d1a23514ca";
export const PRODUCT_VERSION = "2.0.0";
export const BACKEND_COMPATIBILITY_VERSION = "v1.3.4";
export const FRONTEND_COMPATIBILITY_VERSION = "1.1.0";
export const SCADA_DOCUMENT_SCHEMA_VERSION = 3;
export const COMPONENT_CONTRACT_SCHEMA_VERSION = 3;
export const COMPONENT_LIBRARY_MANIFEST_SCHEMA_VERSION = 2;
export const COMPONENT_METADATA_SCHEMA_VERSION = 1;
export const DEFAULT_COMPONENT_ASSET_VERSION = "1.0.0";
export const MONITORING_VALUES_PROTOCOL_VERSION = 2;
export const PROJECT_DATA_PROTOCOL_VERSION = 1;
export const MOBILE_DISCOVERY_PROTOCOL_VERSION = "1.0";
export const VERSION_CATALOG = Object.freeze({
  "catalogFormat": 1,
  "product": {
    "current": "2.0.0",
    "description": "The single uSense product release version shown to operators and used by release tooling.",
    "increaseWhen": {
      "major": "Breaking product, API, or compatibility changes.",
      "minor": "Backward-compatible product features.",
      "patch": "Bug fixes that do not break stored data, APIs, or compatibility."
    },
    "legacyCompatibility": {
      "backend": "v1.3.4",
      "frontend": "1.1.0"
    }
  },
  "domains": {
    "backup": {
      "current": 4,
      "minimumReadable": 1,
      "description": "The signed .usense envelope, compression, encryption, manifest, and payload layout.",
      "increaseWhen": "Increase when a reader must understand a new archive envelope or mandatory manifest structure.",
      "schemas": {
        "archive": {
          "current": 4,
          "minimumReadable": 1,
          "description": "Binary .usense envelope and payload format.",
          "structure": "Envelope header plus signed, optionally encrypted and compressed payload containing manifest.json and checksummed files.",
          "increaseWhen": "Increase when the envelope, required manifest fields, cryptography, compression, or payload layout needs a new reader branch."
        }
      }
    },
    "component": {
      "current": 2,
      "minimumReadable": 1,
      "defaultAssetVersion": "1.0.0",
      "description": "SCADA component contracts and metadata formats used by system and imported components.",
      "increaseWhen": "Increase when the component framework requires metadata or contract compatibility handling.",
      "schemas": {
        "contract": {
          "current": 3,
          "minimumReadable": 2,
          "description": "Properties, bindings, behaviors, events, and script access exposed by component types.",
          "structure": "Canonical component type contracts and generated backend/frontend contract artifacts.",
          "increaseWhen": "Increase when a component contract adds a mandatory field or changes or removes an existing property, binding, behavior, event, or script API."
        },
        "libraryManifest": {
          "current": 2,
          "minimumReadable": 1,
          "description": "System component library profiles, categories, groups, and overlays.",
          "structure": "System component manifest, palette groups, categories, assets, default sizes, bindings, overlays, and parts.",
          "increaseWhen": "Increase when manifest readers need new parsing or migration logic rather than optional backward-compatible data."
        },
        "metadata": {
          "current": 1,
          "minimumReadable": 1,
          "description": "component.json and embedded SVG SCADA metadata structure.",
          "structure": "Per-component component.json plus embedded SVG scada metadata, IDs, bindings, overlays, properties, and part behaviors.",
          "increaseWhen": "Increase when imported component packages or embedded metadata require conversion before use."
        }
      }
    },
    "configuration": {
      "current": 6,
      "minimumReadable": 1,
      "description": "Configuration persisted for projects, screens, tags, variables, users, and device behavior.",
      "increaseWhen": "Increase when at least one configuration sub-schema changes and requires compatibility handling.",
      "schemas": {
        "mainDatabase": {
          "current": 4,
          "minimumReadable": 1,
          "migrationHead": "2026-10-09-0900-channel-conversion",
          "description": "SQLite configuration database controlled by the ordered Gormigrate ledger.",
          "structure": "config.db tables, columns, constraints, indexes, and the ordered backend migration ledger.",
          "increaseWhen": "Increase when persisted database structure or meaning requires a new migration or compatibility adapter."
        },
        "scadaDocument": {
          "current": 3,
          "minimumReadable": 1,
          "description": "Persisted SCADA screen/dashboard JSON consumed by Designer, Runtime, and Simulation.",
          "structure": "Dashboard metadata, objects, properties, bindings, behaviors, events, scripts, layers, and popup presentation JSON.",
          "increaseWhen": "Increase when persisted screen JSON needs migration, renamed fields, new mandatory fields, or changed field semantics."
        },
        "variableStore": {
          "current": 1,
          "minimumReadable": 1,
          "description": "variable.sqlite definitions and retained values.",
          "structure": "Variable definitions, scope ownership, data type, default value, and retained runtime value records.",
          "increaseWhen": "Increase when variable definitions or retained-value storage cannot be read with the current parser unchanged."
        }
      }
    },
    "operationalData": {
      "current": 2,
      "minimumReadable": 1,
      "description": "Runtime history that may optionally be included in a maintenance backup.",
      "increaseWhen": "Increase when an alert or tag-history format changes and needs a new reader or migrator.",
      "schemas": {
        "alertDatabase": {
          "current": 1,
          "minimumReadable": 1,
          "description": "alert.sqlite alarm history, active state, counters, and deduplication data.",
          "structure": "Alarm event history, current active states, timestamps, counters, and deduplication records in alert.sqlite.",
          "increaseWhen": "Increase when alarm history or active-state records require a new reader, writer, or data migration."
        },
        "utsdb": {
          "current": 1,
          "minimumReadable": 1,
          "description": "UTSDB tag-history files and their on-disk record format.",
          "structure": "Time-series directory layout, series metadata, timestamp/value records, and on-disk encoding.",
          "increaseWhen": "Increase when stored time-series files or record encoding cannot be read by the existing UTSDB implementation unchanged."
        }
      }
    }
  },
  "protocols": {
    "mobileDiscovery": {
      "current": "1.0",
      "description": "UDP mobile discovery response protocol.",
      "increaseWhen": "Increase when the discovery request or response wire contract changes incompatibly."
    },
    "monitoringValues": {
      "current": "2",
      "description": "Monitoring-scoped Runtime value snapshot and MQTT delta payload.",
      "increaseWhen": "Increase when existing consumers cannot decode the topic layout, payload fields, or value semantics unchanged."
    },
    "projectData": {
      "current": "1",
      "description": "Project catalog, snapshot, and MQTT delta payload.",
      "increaseWhen": "Increase when project-data request, snapshot, or delta consumers require a compatibility branch."
    }
  },
  "revisions": {
    "alertTagCurrentVersion": {
      "managedBy": "runtime",
      "description": "Automatically snapshots meaningful Alarm Tag configuration changes.",
      "trigger": "A meaningful Alarm Tag configuration change is successfully persisted."
    },
    "alertTypeCurrentVersion": {
      "managedBy": "runtime",
      "description": "Automatically snapshots meaningful Alarm Type configuration changes.",
      "trigger": "A meaningful Alarm Type configuration change is successfully persisted."
    },
    "projectConfigurationRevision": {
      "managedBy": "runtime",
      "description": "Automatically increases when project-level runtime configuration changes.",
      "trigger": "Project-level runtime configuration is successfully persisted."
    },
    "scadaConfigVersion": {
      "managedBy": "runtime",
      "description": "Automatically increases when a screen configuration or project assignment changes.",
      "trigger": "Screen configuration or project assignment is successfully persisted."
    }
  }
});
export const VERSION_PROFILES = Object.freeze({
  "backup": {
    "domain": "backup",
    "profiles": [
      {
        "version": 1,
        "schemas": {
          "archive": 1
        },
        "notes": "Legacy Maintenance archive V1."
      },
      {
        "version": 2,
        "schemas": {
          "archive": 2
        },
        "notes": "Legacy Maintenance archive V2."
      },
      {
        "version": 3,
        "schemas": {
          "archive": 3
        },
        "notes": "Signed Maintenance archive V3 baseline."
      },
      {
        "version": 4,
        "schemas": {
          "archive": 4
        },
        "notes": "Maintenance V4 manifest with centralized product, profile, and sub-schema compatibility metadata."
      }
    ]
  },
  "component": {
    "domain": "component",
    "profiles": [
      {
        "version": 1,
        "schemas": {
          "contract": 2,
          "libraryManifest": 2,
          "metadata": 1
        },
        "notes": "Baseline profile for maintenance ComponentSchema 1."
      },
      {
        "version": 2,
        "schemas": {
          "contract": 3,
          "libraryManifest": 2,
          "metadata": 1
        },
        "notes": "Standardize SCADA option controls as numeric single-selection values and preserve released configurations through compatibility adapters."
      }
    ]
  },
  "configuration": {
    "domain": "configuration",
    "profiles": [
      {
        "version": 1,
        "schemas": {
          "mainDatabase": 1,
          "scadaDocument": 1,
          "variableStore": 1
        },
        "notes": "Legacy Maintenance V3 aggregate schema mapped to the initial tracked sub-schema baseline."
      },
      {
        "version": 2,
        "schemas": {
          "mainDatabase": 1,
          "scadaDocument": 2,
          "variableStore": 1
        },
        "notes": "Baseline profile adopted when centralized version management was introduced."
      },
      {
        "version": 3,
        "schemas": {
          "mainDatabase": 2,
          "scadaDocument": 2,
          "variableStore": 1
        },
        "notes": "Retire duplicated legacy Alarm runtime data from the configuration database"
      },
      {
        "version": 4,
        "schemas": {
          "mainDatabase": 3,
          "scadaDocument": 2,
          "variableStore": 1
        },
        "notes": "Add versioned MQTT Send Profiles with extensible JSON config and multi-rule Receive Profiles with topic matching and sample-driven parsers."
      },
      {
        "version": 5,
        "schemas": {
          "mainDatabase": 4,
          "scadaDocument": 2,
          "variableStore": 1
        },
        "notes": "Add bidirectional numeric Tag conversion with range-aware writes and legacy Divide compatibility"
      },
      {
        "version": 6,
        "schemas": {
          "mainDatabase": 4,
          "scadaDocument": 3,
          "variableStore": 1
        },
        "notes": "Standardize SCADA option controls as numeric single-selection values and preserve released configurations through compatibility adapters."
      }
    ]
  },
  "operationalData": {
    "domain": "operationalData",
    "profiles": [
      {
        "version": 1,
        "schemas": {
          "alertDatabase": 1,
          "utsdb": 1
        },
        "notes": "Legacy Maintenance V3 aggregate schema mapped to the initial tracked sub-schema baseline."
      },
      {
        "version": 2,
        "schemas": {
          "alertDatabase": 1,
          "utsdb": 1
        },
        "notes": "Baseline profile for maintenance DataSchemaVersion 2."
      }
    ]
  }
});
